import { render, staticRenderFns } from "./ObraForm.vue?vue&type=template&id=ce5034f4&"
import script from "./ObraForm.vue?vue&type=script&lang=js&"
export * from "./ObraForm.vue?vue&type=script&lang=js&"
import style0 from "./ObraForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports